module.exports = __webpack_public_path__ + "static/media/the-talk.a0805a5a.png";